import React, { Component } from 'react';
//import ReactDOM from 'react-dom';
import firebase from './../Firestore'
//import { Link } from 'react-router-dom';
import FileUploader from "react-firebase-file-uploader";
//import config from 'react-global-configuration';


import CategoriaSelector from './CategoriaSelector'
import NavBar from './NavBar'

class Create extends Component {

  categoriaID = React.createRef();

  constructor() {
    super();
    this.ref = firebase.firestore().collection('producto');
    this.state = {
      nombre: '',
      descripcion: '',
      categoriaID: '',
      imagen: '',
      orden: '',
      precio: '',
      seFracciona: 0,
      enStock: 1,
      isUploading: false,
      progress: 0,
      imagenURL: "",
      precioUnico: true,
      diseno: 'pizza'
    };
  }


verCategoria = (e) => {
    //console.log("ref", this.categoriaID.current.value)

    console.log("ref ok", this.categoriaID.current.value)

    // test gaston22572
    const ref2 = firebase.firestore().collection('categoria').doc(this.categoriaID.current.value);
    this.unsubscribe = ref2.get().then((doc) => {
      if (doc.exists) {
        const diseno = doc.data();
        this.setState({
          diseno: diseno.diseno
        });
      } else {
        console.log("No such document!");
      }
    });

    // fin test

  }

  onPreciosTamano = (e) => {
    return
    // lo de abajo quedo sin uso a partri de una modificacion
    switch (e.currentTarget.id) {
      case "precioUnico":
        //this.preciosTamanos.current.value = 0
        document.getElementById("grande").value = ""
        document.getElementById("mediana").value = ""
        document.getElementById("chica").value = ""

        this.setState({
          precioUnico: true,
          precio: Number(document.getElementById("precio").value)
        });

        break;
      case "preciosTamanos":
        //this.preciosTamanos.current.value = 0
        document.getElementById("precio").value = ""

        this.setState({
          precioUnico: false,
          precio: {
            grande: Number(document.getElementById("grande").value),
            mediana: Number(document.getElementById("mediana").value),
            chica: Number(document.getElementById("chica").value)
          }
        });

        break;
      default:

    }


  }

  onChange = (e) => {
    //console.log("ref", this.categoriaID.current.value)

    console.log("ref")


    switch (e.target.name) {
      case "pgrande":
      case "pmediana":
      case "pchica":
        this.setState({

          precio: {
            grande: Number(document.getElementById("grande").value),
            mediana: Number(document.getElementById("mediana").value),
            chica: Number(document.getElementById("chica").value)
          }
        });
        break;
      default:
        const state = this.state
        state[e.target.name] = e.target.value;
        this.setState(state);
    }



  }

  onSubmit = (e) => {
    e.preventDefault();

    const { nombre, descripcion, categoriaID, imagen, imagenURL, orden, precio, seFracciona, enStock } = this.state;

    this.ref.add({
      nombre,
      descripcion,
      categoriaID: this.categoriaID.current.value,
      imagen: this.state.imagenURL !== undefined ? this.state.imagenURL : "",
      orden: Number(this.state.orden) === 0? 100 : this.state.orden,
      precio: typeof this.state.precio === 'object' ? this.state.precio : Number(this.state.precio),
      seFracciona: Boolean(this.state.seFracciona),
      enStock: Boolean(this.state.enStock)
    }).then((docRef) => {
      this.setState({
        nombre: '',
        descripcion: '',
        categoriaID: '',
        imagen: '',
        imagenURL: '',
        orden: '',
        precio: '',
        seFracciona: '',
        enStock: ''
      });
      this.props.history.push("/admin")
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
    });
  }


  //handleChangeUsername = event =>
      //this.setState({ username: event.target.value });
    handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
    handleProgress = progress => this.setState({ progress });
    handleUploadError = error => {
      this.setState({ isUploading: false });
      console.error(error);
    };
    handleUploadSuccess = filename => {
      this.setState({ imagen: filename, progress: 100, isUploading: false });
      firebase
        .storage()
        .ref("productos")
        .child(filename)
        .getDownloadURL()
        .then(url => this.setState({ imagenURL: url }));
    };

  render() {
    const { nombre, descripcion, categoriaID, imagen, orden, precio, seFracciona, enStock } = this.state;
    return (
      <div className="container">
        <NavBar history={this.props.history} />
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              AGREGAR PRODUCTO
            </h3>
          </div>
          <div className="panel-body">
            <form className="bg-light p-2" onSubmit={this.onSubmit}>
              <div className="form-group border border-primary rounded p-2">

                <label htmlFor="nombre"><strong>Nombre:</strong></label>
                <input type="text" className="form-control" name="nombre" value={nombre} onChange={this.onChange} placeholder="Nombre" required />
              </div>
              <div className="form-group border border-primary rounded p-2">
                <label htmlFor="descripcion"><strong>Descripcion:</strong></label>
                <textarea value={descripcion} className="form-control" name="descripcion" onChange={this.onChange} placeholder="Descripcion" cols="80" rows="3" />
              </div>
              <div className="form-group border border-primary rounded p-2" onClick={this.verCategoria}>
                <label htmlFor="categoriaID"><strong>Categoria:</strong></label>
                <CategoriaSelector name="categoriaID" categoriaID={this.categoriaID} onChange={this.onChange}  />

              </div>


                <div className="form-group border border-primary rounded p-2">
                  <div className="row">

                    {this.state.diseno !== "pizza" ? (
                    <div className="col mr-3" id="precioUnico" onFocus={this.onPreciosTamano}>
                        <div className="form-group">
                          <label htmlFor="precio"><strong>Precio único:</strong></label>
                          <input id="precio" type="number" className="form-control" name="precio" value={typeof precio !== 'object'? precio : ""} onChange={this.onChange} placeholder="Precio único" min="1" required={this.state.precioUnico ? true : false} />
                        </div>
                    </div>
                    ) : (

                    <div id="preciosTamanos" onFocus={this.onPreciosTamano} className="col ml-3">
                        <div >
                          <label htmlFor="grande">Tamaño <strong>grande</strong>:</label>
                          <input type="number" id="grande" className="form-control" name="pgrande"  onChange={this.onChange} placeholder="Precio Grande" min="0" />
                          <label htmlFor="mediano">Tamaño <strong>mediano</strong>:</label>
                          <input type="number" id="mediana" className="form-control" name="pmediana" value={precio.mediana} onChange={this.onChange} placeholder="Precio Mediana" min="0" />
                          <label htmlFor="chica">Tamaño <strong>chico</strong>:</label>
                          <input type="number" id="chica" className="form-control" name="pchica" value={precio.chica} onChange={this.onChange} placeholder="Precio Chica" min="0" />
                        </div>
                    </div>
                    )}
                  </div>
                </div>

                <div className="form-group border border-primary rounded p-2">
                  <span className="d-block mt-2"><strong>Imagen</strong> del producto:</span><br/>
                  <small>Tamaño recomendado 400px x 300px</small><br/>
                  {this.state.isUploading && <p>Progress: {this.state.progress}</p>}
                  {this.state.imagenURL && <img src={this.state.imagenURL} alt={this.state.nombre} />}
                  <FileUploader
                    accept="image/*"
                    name="producto"
                    randomizeFilename
                    storageRef={firebase.storage().ref("productos")}
                    onUploadStart={this.handleUploadStart}
                    onUploadError={this.handleUploadError}
                    onUploadSuccess={this.handleUploadSuccess}
                    onProgress={this.handleProgress}
                    maxHeight="300"
                    maxWidth="400"
                  />
              </div>

              <div className="form-group mt-2 border border-primary rounded p-2">
                  <small className="d-block">El orden en número que determinará que productos aparecerán mas arriba (0 es el nivel mas alto)</small>
                  <label htmlFor="orden"><strong>Orden:</strong></label>
                  <input type="number" className="form-control" name="orden" value={orden} onChange={this.onChange} placeholder="Orden" />
                </div>

              <div className="form-group mt-2 border border-primary rounded p-2">
                <small>Ej. una pizza se puede pedir mitad muzza, mitad napo (se fracciona), en cambio una empanada o una bebida no (No se fracciona)</small>
                <select value={seFracciona} name="seFracciona" onChange={this.onChange} className="custom-select mt-2">
                  <option value={false}>No se Fracciona</option>
                  <option value={true}>Se fracciona</option>
                </select>
              </div>


              <div className="form-group mt-2 border border-primary rounded p-2">
                <small>Los productos que No hay en stock, NO se mostrarán en el listado de productos a los usaurios de la App</small>
                <select value={enStock} name="enStock" onChange={this.onChange} className="custom-select mt-2">
                  <option value={true}>Hay en stock</option>
                  <option value={false}>No hay en stock</option>
                </select>
            </div>


              <button type="submit" className="btn btn-lg btn-primary mt-2 btn-block">Agregar producto</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Create;
